import axios from 'axios';

const IDENTITY_API_BASE_URL = process.env.REACT_APP_IDENTITY_URL || 'http://localhost:8080';

const identityApi = axios.create({
  baseURL: IDENTITY_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export const identityService = {
  /**
   * Register a new user
   */
  register: async (userData) => {
    const response = await identityApi.post('/api/auth/register', userData);
    return response.data;
  },

  /**
   * Login with email and password
   */
  login: async (credentials) => {
    const response = await identityApi.post('/api/auth/login', credentials);
    return response.data;
  },

  /**
   * Request password reset
   */
  forgotPassword: async (email) => {
    const response = await identityApi.post('/api/auth/forgot-password', { email });
    return response.data;
  },

  /**
   * Reset password with token
   */
  resetPassword: async (resetData) => {
    const response = await identityApi.post('/api/auth/reset-password', resetData);
    return response.data;
  },

  /**
   * Confirm email with token
   */
  confirmEmail: async (token) => {
    const response = await identityApi.get(`/api/auth/confirm-email?token=${token}`);
    return response.data;
  },

  /**
   * Logout current user
   */
  logout: async () => {
    const response = await identityApi.post('/api/auth/logout');
    return response.data;
  },

  /**
   * Get current user profile
   */
  getProfile: async (accessToken) => {
    const response = await identityApi.get('/api/user/profile', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  },

  /**
   * Update user profile
   */
  updateProfile: async (profileData, accessToken) => {
    const response = await identityApi.put('/api/user/profile', profileData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  },

  /**
   * Change password
   */
  changePassword: async (passwordData, accessToken) => {
    const response = await identityApi.put('/api/user/change-password', passwordData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  },

  /**
   * Get personal data (GDPR)
   */
  getPersonalData: async (accessToken) => {
    const response = await identityApi.get('/api/user/personal-data', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  },

  /**
   * Delete account (GDPR)
   */
  deleteAccount: async (accessToken) => {
    const response = await identityApi.delete('/api/user/account', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  },
};

export default identityService;
